import { fetchData } from "./FetchServices";

export async function fetchConfig() {
  return fetchData('config/getConfig.php')
}
